export const USER_REGISTRATION_METHOD_SCHEMA = [
  "EMAIL_PASSWORD",
  "GITHUB",
  "GOOGLE",
] as const;

export type UserRegistrationMethod =
  (typeof USER_REGISTRATION_METHOD_SCHEMA)[number];
